import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import type { IResourceDatabaseRecord, IResourceViewProps } from '@/api/types';

import { otherColors } from '@/styles/colors';
import { ResourceDatabaseItemValue } from '@/components/common/resources/ResourceDatabaseItemValue';
import { ID_COLUMN_NAME } from '@/config/variables';

interface IProps {
  resource: IResourceDatabaseRecord;
  databaseFields: IResourceViewProps[];
}

const DatabaseViewItemPreview = ({ resource, databaseFields }: IProps): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Container>
      {databaseFields.map(column => {
        const value = resource[column.field.name === ID_COLUMN_NAME ? column.field.properties : column.field.name];
        return (
          <div key={column.field.columnName}>
            <Title>{column.field.name}</Title>
            <TitleText>
              {value ? (
                <ResourceDatabaseItemValue columnType={column.field.rtxtype_Id} isPreview>
                  {/* For some reason id column name is in properties instead */}
                  {value}
                </ResourceDatabaseItemValue>
              ) : (
                t`common.labelNotAvailable`
              )}
            </TitleText>
          </div>
        );
      })}
    </Container>
  );
};

export { DatabaseViewItemPreview };

const Container = styled.div`
  margin-top: 24px;
  overflow: auto;
`;

const Title = styled.div`
  display: flex;
  font-size: 24px;
  font-weight: 300;
  color: ${otherColors.lxc.darkBlue};
`;

const TitleText = styled.h1`
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  margin-top: 5px;
  margin-bottom: 26px;
`;
